import { Text } from '@mantine/core';
import { memo } from 'react';
import Markdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';

import { normalizeLatexDelimiters } from 'app/modules/wallforming/components/copilot/utils/copilotUtils';

import type { CopilotMessage } from 'app/modules/wallforming/components/copilot/types/copilotTypes';

import 'katex/dist/katex.min.css';

const MARKDOWN_REHYPE_PLUGINS = [rehypeKatex];
const MARKDOWN_REMARK_PLUGINS = [remarkGfm, remarkMath];
const MARKDOWN_DISALLOWED_ELEMENTS = ['img'];

export const CopilotMessageContent = memo(function CopilotMessageContent({
    content,
    role
}: {
    content: string;
    role: CopilotMessage['role'];
}) {
    return role === 'user' ? (
        <Text className="min-w-0 flex-1 whitespace-pre-wrap wrap-break-word" size="sm">
            {content}
        </Text>
    ) : (
        <div
            className="min-w-0 flex-1 overflow-x-auto text-sm wrap-break-word [&_p]:my-2 [&_p:first-child]:mt-0 [&_p:last-child]:mb-0 [&_strong]:font-bold [&_em]:italic [&_h1]:text-xl [&_h2]:text-lg [&_h3]:text-base [&_h1]:font-semibold [&_h2]:font-semibold [&_h3]:font-semibold [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_pre]:overflow-x-auto [&_pre]:rounded [&_pre]:bg-background-gray-ultra-light [&_pre]:p-2 [&_code]:font-mono [&_a]:text-text-accent [&_a]:underline [&_blockquote]:border-l-2 [&_blockquote]:border-border-light [&_blockquote]:pl-3 [&_table]:border-collapse [&_th]:border [&_th]:border-border-light [&_td]:border [&_td]:border-border-light [&_td]:p-2"
            data-copilot-message-content
        >
            <Markdown
                disallowedElements={MARKDOWN_DISALLOWED_ELEMENTS}
                rehypePlugins={MARKDOWN_REHYPE_PLUGINS}
                remarkPlugins={MARKDOWN_REMARK_PLUGINS}
                skipHtml
            >
                {normalizeLatexDelimiters(content)}
            </Markdown>
        </div>
    );
});
